import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

type SettingsSectionProps = {
	title: React.ReactNode
	description?: React.ReactNode
	children: React.ReactNode
	className?: string
	headerAction?: React.ReactNode
}

export function SettingsSection({
	title,
	description,
	children,
	className,
	headerAction,
}: SettingsSectionProps) {
	return (
		<Card className={className || 'max-w-[48rem]'}>
			<CardHeader>
				<CardTitle className={headerAction ? 'flex items-center justify-between gap-2' : ''}>
					{title}
					{headerAction}
				</CardTitle>

				{description && <CardDescription>{description}</CardDescription>}
			</CardHeader>

			<CardContent>{children}</CardContent>
		</Card>
	)
}
